import { render, staticRenderFns } from "./FragmentPicture.vue?vue&type=template&id=06fb85bc"
import script from "./FragmentPicture.vue?vue&type=script&lang=ts"
export * from "./FragmentPicture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports